import { Application } from '@splinetool/runtime';

async function init() {
  const sceneURLs = Object.values(
    import.meta.glob('@assets/spline/*.splinecode', {
      eager: true,
      query: '?url',
      import: 'default',
    }),
  );

  const list = document.querySelector('.js-animations-list');
  sceneURLs.forEach((sceneURL) => {
    const li = document.createElement('li');
    const figure = document.createElement('figure');
    const canvas = document.createElement('canvas');
    const figcaption = document.createElement('figcaption');

    figcaption.textContent = sceneURL;

    figure.appendChild(canvas);
    figure.appendChild(figcaption);
    li.appendChild(figure);
    list.appendChild(li);

    // Init spline animation
    canvas.getContext('webgl2', { preserveDrawingBuffer: true });
    let spline = new Application(canvas);
    spline.load(sceneURL);
  });

  console.log(sceneURLs);
}

init();
